import gql from 'graphql-tag';
import { reportRecordGQLFields, } from './reportRecord.fields.js';
export const analyticsGQLQuery = (fields) => gql `
  query Analytics($queries: [String!]!) {
    analytics(queries: $queries) {
      query
      records {
        ${reportRecordGQLFields(fields)}
      }
    }
  }
`;
//# sourceMappingURL=analytics.gql.js.map